"use client"

import { useCreditFormatters } from "@/hooks/use-credit-formatters"
import { createTranslator, useTranslations } from "next-intl"
import english from "@/translations/en/billing.json"

const englishTranslator = createTranslator({locale: "en", messages: english, namespace: "Billing.QualitySpend"})

import { formatCreditsShort } from '@/lib/billing/utils/credits'

export interface QualitySpend {
  qualityCount: number
  qualityCharges: number
  qualityPlatformCount: number
}

/** Under Text: what Conversation Quality took of it, and what the platform paid instead. */
export function QualitySpendLine({ usage }: { usage: QualitySpend }) {
  const t = useTranslations("Billing.QualitySpend")
  const { formatCreditsShort } = useCreditFormatters()
  const text = qualitySpendText(usage, t, formatCreditsShort)
  return text ? <div key={text} className="text-xs text-muted-foreground mt-0.5">{text}</div> : null
}

/**
 * The month's own numbers decide the wording, never the current payer, so a past month
 * reads right after the payer changed.
 */
export function qualitySpendText({ qualityCount, qualityCharges, qualityPlatformCount }: QualitySpend, t: ReturnType<typeof useTranslations<"Billing.QualitySpend">> = englishTranslator, creditsShort: typeof formatCreditsShort = formatCreditsShort): string | null {
  const requests = qualityCount + qualityPlatformCount
  if (requests === 0) return null

  const parts = [t("requests", {count: requests})]
  if (qualityCount > 0) parts.push(creditsShort(qualityCharges))
  if (qualityPlatformCount > 0) {
    parts.push(qualityCount > 0 ? t("notChargedCount", {count: qualityPlatformCount}) : t("notCharged"))
  }
  return t("line", {parts: parts.join(" · ")})
}
